export default "__VITE_ASSET__Umy8RQcK__"